function OffenderSexOffense() {
    "use strict";

    this.__type = 'OffenderSexOffense:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;
    this.IsActive = true;
    this.SexOffenseId = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = OffenderSexOffense;
}